import React from 'react';
import { useTheme } from 'emotion-theming';
import type { SerializedStyles } from '@emotion/core';
// @ts-expect-error checkout/react-components
import { LoadingElement as LoadingElementComponent } from '@checkout/react-components';
import {
  getLoadingElementStyles,
  loadingElementStyleOverrides,
} from './styles';

type LoadingElementProps = {
  height?: string;
  styleOverrides?: SerializedStyles;
  viewBoxHeight?: string;
};

const LoadingElement = ({
  height,
  styleOverrides,
  viewBoxHeight,
}: LoadingElementProps): React.ReactElement => {
  const theme: AppTheme.WeasleyTheme = useTheme();

  return (
    <LoadingElementComponent
      {...getLoadingElementStyles({ height, theme, viewBoxHeight })}
      styleOverrides={[loadingElementStyleOverrides, styleOverrides]}
    />
  );
};

export { LoadingElement };
